export default (theme) => ({
  font: {
    // fontFamily: 'open-sans, sans-serif',
    // color: theme.palette.type === 'dark' ? 'white' : 'black',
  },
});
